import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
} from 'react';

import locationLabelText from '@tmap/mmm-core/locationLabelText';

import { Autocomplete } from '@tmap/mmm-style-guide/src/Autocomplete';
import useDebounced from '@tmap/mmm-style-guide/src/useDebounced';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { TextField } from '@tmap/mmm-style-guide/src/TextField';

import { searchCommunitiesByName } from '../actions/community';

export default function CommunityAutocomplete(props) {
  const {
    value,
    setValue,
    useThunk,
    color = 'primary',
    label = 'Moving To',
    ...autocompleteProps
  } = props;
  const [inputValue, setInputValue] = useState('');

  const [state, getAutocomplete] = useThunk(searchCommunitiesByName);
  const autocomplete = useMemo(() => state.data || [], [state.data]);

  const fetchAutocomplete = useDebounced(getAutocomplete, 400);

  useEffect(() => {
    if (inputValue) fetchAutocomplete(inputValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  const filledInput = Boolean(inputValue);
  const autocompleteFetched = filledInput ? Boolean(autocomplete) : false;

  const isOptionEqualToValue = (option, currentValue) => (
    option._id === currentValue?._id
  );

  const renderInput = useCallback((inputProps) => (
    <TextField
      {...inputProps}
      color={color}
      label={label}
    />
  ), [color, label]);

  const renderOption = useCallback((optionProps, option) => (
    <li {...optionProps} key={option?._id}>
      <Grid container alignItems='center'>
        <Grid item xs>
          {locationLabelText(option?.locationText, option?.regionText)}
        </Grid>
      </Grid>
    </li>
  ), []);

  return (
    <Autocomplete
      color={color}
      fullWidth
      noOptionsText={autocompleteFetched ? 'No matching locations' : 'Type to search'}
      getOptionLabel={(option) => locationLabelText(option?.locationText, option?.regionText)}
      isOptionEqualToValue={isOptionEqualToValue}
      filterOptions={(opts, muiState) => opts.filter((i) => {
        const itemName = [i?.locationText, i?.regionText].join(' ').toLowerCase();
        const inputTokens = muiState.inputValue.toLowerCase().split(/[\s,]+/);
        return inputTokens.some((token) => itemName.indexOf(token) >= 0);
      })}
      options={autocomplete}
      autoComplete
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={renderInput}
      renderOption={renderOption}
      {...autocompleteProps}
    />
  );
}
